export const OT = () => import('./.node_modules/@opentok/client')

// export * from './.node_modules/@opentok/client'

export { debug } from '/vodalys/.jslibs/'
export { pastelColor } from '/vodalys/.jslibs/'


export const sleep = async (time = 1000) =>
  new Promise((resolve) => setTimeout(resolve, time));